import {tabelleDiSistemaApi} from "@commons/features/sistema/tabelleDiSistema.api";
import {ULTabellaCCNLApi} from "@commons/features/sistema/ULTabellaCCNL.api";
import {ULLivelliCCNLApi} from "@commons/features/sistema/ULLivelliCCNL.api";
import {comuniApi, provinceApi} from "@commons/features/sistema/ComuniEProv.api";
import {elementiRMLApi} from "@commons/features/elementiRML/ElementiRML.api";

export const sistemaReducers = {
    [tabelleDiSistemaApi.reducerPath]: tabelleDiSistemaApi.reducer,
    [provinceApi.reducerPath]: provinceApi.reducer,
    [comuniApi.reducerPath]: comuniApi.reducer,
    [ULTabellaCCNLApi.reducerPath]: ULTabellaCCNLApi.reducer,
    [ULLivelliCCNLApi.reducerPath]: ULLivelliCCNLApi.reducer,
    [elementiRMLApi.reducerPath]: elementiRMLApi.reducer,
}
export const sistemaMiddlewares = [
    tabelleDiSistemaApi.middleware,
    provinceApi.middleware,
    comuniApi.middleware,
    ULTabellaCCNLApi.middleware,
    ULLivelliCCNLApi.middleware,
    elementiRMLApi.middleware,
]